import { contentApi, zimbaApi } from '@/infrastructure/Configuration'

export default class BlogService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getPromotedArticlesList (filter) {
    const url = `${contentApi}/blog/article-lists/${filter.pageId}`
    const response = await this.httpClient.get(url)
    return response.data
  }

  async getArticles (params) {
    const url = `${zimbaApi}/blog/articles`
    const response = await this.httpClient.get(url, { params })
    return response.data
  }
}
